import React from "react";
import ErrorField from "./error";
import { PisValues } from "core/enum";
import { observer } from "mobx-react";
import { SelectField } from "components/support";

const PisOptions = Object.values(PisValues).map(p => ({
  value: p.value,
  label: p.label
}));

const PisField = ({ errors, row, onChange }) => {
  const { taxes } = row || {};
  const foundErrors = errors.find(v => v.name === row.name);
  const hasErrors =
    foundErrors &&
    !!foundErrors.errors &&
    !!foundErrors.errors.taxes &&
    !!foundErrors.errors.taxes.pis;

  return (
    <div>
      {
        <SelectField
          fullWidth
          options={PisOptions}
          value={taxes.pis}
          onChange={(_, value) => onChange(value)}
        />
      }
      {hasErrors && <ErrorField error={foundErrors.errors.taxes.pis} />}
    </div>
  );
};

export default observer(PisField);



// WEBPACK FOOTER //
// ./src/components/app/registration/product/batch/fields/pis.js